import styled from 'styled-components'
export const StyledQuestion = styled.div`
h1 {
  text-align: center;
  font-size: 1.4em;
  margin: 1rem;
  font-weight: 300;
}
h2 {
  text-align: center;
  font-size: 2.2em;
  margin: 1rem;
  font-weight: 300;
}
h3 {
  text-align: center;
  font-size: 1.4em;
  margin: 1rem;
  font-weight: 300;
}

@media (orientation:portrait) {
  h3 {
    margin-bottom: 1rem;
  }
}

`
